//import master JS file
import './src/app.js';

//import master SCSS file
import './src/sass/app.scss';
